module.exports = __webpack_public_path__ + "img/Access Bank.1b598674.png";